import type { RootState } from "types";

export const getWhatsNewStories = (state: RootState) => state.domains.whatsNew.data?.stories;

export const showWhatsNewIcon = (state: RootState) => !!state.domains.whatsNew.data;
